import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const s = () => /* @__PURE__ */ o.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", children: [
  /* @__PURE__ */ o.jsx("path", { d: "m15.002 14.997 -6 -6m6 0 -6 6", stroke: "currentColor", strokeWidth: "2.0000025", strokeLinecap: "round" }),
  /* @__PURE__ */ o.jsx(
    "path",
    {
      d: "M12.001 21.997c5.523 0 10 -4.477 10 -10S17.524 1.998 12 1.998 2.001 6.476 2.001 11.998s4.478 10 10 10Z",
      stroke: "currentColor",
      strokeWidth: "2.0000025"
    }
  )
] });
export {
  s as C
};
